import { number, object, string } from "yup";
import { DOSE_MgKg } from "duck";

export const getValidation = () => {
  const validationSchema = object().shape(
    {
      name: string()
        .default(null)
        .required()
        .nullable(),
      doseMin: number()
        .required("Dose Range can’t be blank.")
        .nullable()
        .transform(value => (Number.isNaN(value) ? 0 : value))
        .when("doseMax", (value, schema) => {
          if (value) {
            return schema.lessThan(
              value,
              "Max dose value can't be lower than min dose."
            );
          }
        }),
      doseMax: number()
        .required("Dose Range can’t be blank.")
        .nullable()
        .transform(value => (Number.isNaN(value) ? 0 : value))
        .when("doseMin", (value, schema) => {
          if (value) {
            return schema.moreThan(
              value,
              "Max dose value can't be lower than min dose."
            );
          }
        }),
      doseUnit: string()
        .required()
        .nullable()
        .default(DOSE_MgKg),
      concentration: number()
        .required()
        .nullable()
        .transform(value => (Number.isNaN(value) ? 0 : value)),
      volumeToBeInfused: number()
        .nullable()
        .transform(value => (Number.isNaN(value) ? 0 : value)),
      initials: string()
        .nullable()
        .default("")
    },
    [["doseMin", "doseMax"]]
  );

  return {
    validationSchema,
    defaultValues: validationSchema.cast({})
  };
};
